import useWebSocket from 'react-use-websocket';

import { LastWebsocketJsonMessageType } from '@interfaces/webSocketConnectionInfo';

import { useGetWebsocketMsg } from '@core/dashboard/components/DashboardContent/hooks';
import { useHandleWebsocketMsg } from './hooks';

import { useMytaverse } from '@providers/MytaverseProvider';

const DashboardWebsocket = () => {
  const { getWebsocketUrl, getWebSocketOptions } = useMytaverse();

  const getWebsocketMsg = useGetWebsocketMsg();

  const { lastJsonMessage } = useWebSocket(
    getWebsocketUrl,
    getWebSocketOptions({ withReconnection: false }),
  );

  const websocketMsg = getWebsocketMsg(
    lastJsonMessage as LastWebsocketJsonMessageType,
  );

  useHandleWebsocketMsg(websocketMsg);

  return null;
};

export default DashboardWebsocket;
